import { useUnauthenticatedHttpClient } from "src/authentication/hooks/useUnauthenticatedHttpClient";
import useSWR from "swr";
import { UPDATE_POLL_INTERVAL_MS } from "./updatePolling";

export const useLatestVersion = () => {
    const client = useUnauthenticatedHttpClient();

    return useSWR<string>(
        "latest-version",
        async () => {
            const response = await client.get<{ version: string }>("/versions/web");

            return response.data.version;
        },
        { refreshInterval: UPDATE_POLL_INTERVAL_MS },
    );
};
